import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { ICartItem } from "../../stores/cart";
import { AppConfig } from "../../AppConfig";
import defaultImgNa from "../../resources/images/img-default.jpg";
import {
  IAddOnOptionMapping,
  IProductAddOnMapping,
} from "../../stores/products";
import CustomiseAddOns from "./customise-addons";
import { currencyFormatter, getOfferAppliedDesc } from "../../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinusCircle,
  faPlusCircle,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

interface ICartItems {
  cartItems: ICartItem[];
  clearCartItems: Function;
  updateCartItemQuantity: Function;
}

const CartItems = observer(
  ({ cartItems, clearCartItems, updateCartItemQuantity }: ICartItems) => {
    const getSubTotal = (qty: number, price: number) => {
      return qty * price;
    };

    return (
      <div className="cart-table table-responsive mt-2">
        <div className="p-1 d-flex">
          <h6>Order Summary</h6>
          <Link
            className="text-decoration-none ms-auto text-danger"
            to={"#"}
            onClick={() => clearCartItems()}
          >
            Clear Cart
          </Link>
        </div>
        <table className="table">
          <tbody>
            {cartItems.map((cartItem: ICartItem, i) => (
              <tr key={cartItem.productId + i}>
                <td>
                  <img
                    src={
                      cartItem?.productImagePath
                        ? `${AppConfig.APIBaseUrl}${cartItem.productImagePath}`
                        : defaultImgNa
                    }
                    alt="Product"
                    className="object-cover rounded-md"
                    height={55}
                    width={80}
                  />
                  <div className="d-flex align-items-center ms-2">
                    <FontAwesomeIcon
                      icon={faMinusCircle}
                      className="text-danger cursor-pointer"
                      onClick={() => {
                        updateCartItemQuantity(cartItem, -1);
                      }}
                    />
                    <span className="ps-2 pe-2">{cartItem.Quantity}</span>

                    <FontAwesomeIcon
                      icon={faPlusCircle}
                      className="text-success cursor-pointer"
                      onClick={() => {
                        updateCartItemQuantity(cartItem, 1);
                      }}
                    />
                  </div>
                </td>
                <td className="text-dark ms-2">
                  {cartItem.productName}
                  {cartItem.productAddOns &&
                    cartItem.productAddOns.length > 0 && (
                      <div>
                        {cartItem.productAddOns?.map(
                          ({ addOn }: IProductAddOnMapping, i) => {
                            return addOn.addOnOptions.map(
                              ({ addOnOption }: IAddOnOptionMapping) => {
                                if (addOnOption.choosen)
                                  return (
                                    <span
                                      key={addOnOption.addOnOptionName + i}
                                      className="badge bg-primary me-1 p-1 rounded-0 ps-1 pe-1"
                                    >
                                      {`${
                                        addOnOption.addOnOptionName
                                      } ${currencyFormatter(
                                        addOnOption.addOnOptionPrice
                                      )}`}
                                    </span>
                                  );
                              }
                            );
                          }
                        )}
                        <div className="d-flex">
                          <CustomiseAddOns
                            cartItem={cartItem}
                          ></CustomiseAddOns>
                        </div>
                      </div>
                    )}

                  {cartItem.offers && cartItem.offers.length > 0 && (
                    <div>
                      {cartItem.offers.map((o) => (
                        <div className="text-success">
                          {getOfferAppliedDesc(o, cartItem.Quantity)}
                        </div>
                      ))}
                    </div>
                  )}
                </td>
                <td className="product-subtotal text-end">
                  <div className="subtotal-amount">
                    {cartItem.Quantity >= cartItem.discountForQuantity &&
                    cartItem.discountPrice ? (
                      <>
                        <del className="small">
                          {currencyFormatter(
                            getSubTotal(cartItem.Quantity, cartItem.sellPrice)
                          )}
                        </del>
                        <div className="fs-6">
                          {currencyFormatter(
                            getSubTotal(
                              cartItem.Quantity,
                              cartItem.discountPrice
                            )
                          )}
                        </div>
                      </>
                    ) : (
                      currencyFormatter(
                        getSubTotal(cartItem.Quantity, cartItem.sellPrice)
                      )
                    )}
                  </div>
                  {cartItem.addOnsPrice && (
                    <div className="small">
                      + {currencyFormatter(cartItem.addOnsPrice ?? 0)}
                    </div>
                  )}
                </td>
                <td className="text-end">
                  <a
                    className="remove text-danger ms-5"
                    href="#"
                    onClick={() => clearCartItems(cartItem.productId)}
                    title="Remove item"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
);

export default CartItems;
